import "./styles/App.css";
import Header from './components/Header';
import Navbar from "./components/Navbar";
import GlobalProvider from "./context/GlobalContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SetData from "./components/SetData";
import AboutMe from "./components/AboutMe";
import Contact from "./components/Contact";
import SetResume from "./components/SetResume";
import Resume from "./components/Resume";
import Projects from "./components/Projects";
import ProjectDetail from "./components/ProjectDetail";
import Home from "./components/Home";
import Login from "./components/Login";
import SetdataProvider from "./context/SetdataContext";

function App() {
    return (
        <GlobalProvider>
        <SetdataProvider>
            <BrowserRouter>
                <div className="App">
                    <Header />
                    <Navbar />

                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/aboutMe" element={<AboutMe />} />
                        <Route path="/setdata" element={<SetData />} />
                        <Route path="/setresume" element={<SetResume />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/resume" element={<Resume />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/projects/:project" element={<ProjectDetail />}/>
                        
                    </Routes>
                </div>
            </BrowserRouter>
        </SetdataProvider>
        </GlobalProvider>
    );
}

export default App;
